<template>
  <div class="folder-content">
    <div style="display: flex">
      <p>{{ $t('message.title.globalSearch') }}</p>
      <p style="margin-left: auto;">
        <el-button type="text" @click="appendRootData">
          <span class='el-icon-folder-add' />
        </el-button>
      </p>
    </div>
    <el-tree :data="data" node-key="id" default-expand-all :expand-on-click-node="false" :render-content="renderContent"
      :props="defaultLabel" />
    <el-divider />
    <div style="display: flex">
      <p>{{ $t('message.title.personalSearch') }}</p>
      <p style="margin-left: auto;">
        <el-button type="text" @click="appendPersonnalFolder">
          <span class='el-icon-folder-add' />
        </el-button>
      </p>
    </div>
    <el-tree :data="personalData" node-key="id" default-expand-all :expand-on-click-node="false"
      :render-content="renderContent" :props="defaultLabel" />

  </div>


</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      data: [],
      personalData: [],
      defaultLabel: {
        label: 'name',
        value: 'id'
      }
    }
  },
  methods: {
    renderContent(h, { node, data, store }) {

      const prevIcon = data.baseId ? ' el-icon-search' : 'el-icon-folder-opened';
      const hiddeEdit = !data.baseId ? '' : 'hidde-edit';
      // :class="getActive(item)"
      return (
        <div class="custom-tree-node" style='display:flex;width:100%;align-items:center'>
          <div style=' flex: 1;  align-items: center;  font-size: 12px;  white-space: nowrap;  overflow: hidden;  text-overflow: ellipsis;' on-click={() => this.handleClick(node, data)} >
            <span class={prevIcon} > </span>
            {node.label}
          </div>
          <div class='btns' style="margin-left: auto;margin-right:10px;flex-basis:60px">
            <el-button size="mini" type="text" on-click={() => this.editFolder(data)}  >
              <span class='el-icon-edit' />
            </el-button>
            <el-button class={hiddeEdit} size="mini" type="text" on-click={() => this.append(data)}  >
              <span class='el-icon-folder-add' />
            </el-button>
            <el-button size="mini" type="text" on-click={() => this.remove(node, data)}>
              <span class='el-icon-delete' />
            </el-button>
          </div>
        </div >);
    },
    appendRootData() {
      this.append({ id: 0, type: 3 })
    },
    appendPersonnalFolder() {
      this.append({ id: 0, type: 4 })
    },

    append(data) {
      console.log('apppend');
      this.$prompt('请输入名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        if (!value || value.trim() === '') {
          this.$message({
            showClose: true,
            type: 'error',
            message: '请输入有效值'
          });
        } else {
          const obj = {
            "enabled": 1,
            "id": data?.childId || null,
            "name": value,
            "parentId": data.id,
            "type": data.type
          }
          return this.addOrUpdateFolder(obj);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },

    editFolder(data) {
      this.$prompt('请输入名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',

      }).then(({ value }) => {
        console.log(value);
        return this.updateFolder(data, value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },

    handleClick(node, data) {
      if (data?.baseId) {
        const query = { seekId: data.id, seekName: data.name }
        this.$router.push({ path: '/folderList', query })
      }
    },

    updateFolder(data, value) {
      if (data.baseId) {
        const obj = {
          id: data.id,
          name: value
        }
        axios.post(`/pmdm/folder/updateSearchName`, obj).then(res => {
          this.$message({
            type: 'success',
            message: 'success'
          });
          this.getData();
        }).catch()
      } else {
        const obj = {
          "enabled": 1,
          "id": data.id || null,
          "name": value,
          "parentId": data.parentId,
          "type": data.type
        }
        this.addOrUpdateFolder(obj)
      }

    },

    addOrUpdateFolder(obj) {
      axios.post(`/pmdm/folder/saveOrUpdateFolder`, obj).then(res => {
        if (res.data.code == 200) {
          this.$message({
            type: 'success',
            message: 'success'
          });
        }
        this.getData();
      }).catch()
    },
    remove(node, data) {
      // console.log(('re,ovw'));
      console.log(data);

      if (data.baseId) {
        this.deleteSearch(data);
        return
      }
      axios.get('/pmdm/folder/deleteFolderById?id=' + data.id).then(res => {
        this.$message({
          type: 'success',
          message: 'success'
        });
        this.getData();
        this.updateTree();

        const { seekId } = this.$route.query;
        console.log('asdfasdgasdfa', seekId);

        if (data.id == seekId) {
          this.$router.push('/folderList')
        }
      })
    },
    deleteSearch(data) {
      //     console.log(e);(this.loadedSearch);
      this.$confirm(
        this.$t("message.confirm.deleteSearch"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          axios
            .post("/pmdm/admin/criteria/deleteSeekById?seekId=" + data.id)
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data.message,
                });
                this.getData();
                this.updateTree();
                const { seekId } = this.$route.query;
                console.log('asdfasdgasdfa', seekId);

                if (data.id == seekId) {
                  this.$router.push('/folderList')
                }
              }
            })
            .catch(function (error) {

            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.deleteCancel"),
          });
        });
    },
    formatTree(arr) {
      arr.map(i => {
        const { children, seekList } = i;
        i.children = [...children, ...seekList];
        if (!!children.length) {
          this.formatTree(children)
        }
      })
      return arr
    },

    getData() {
      axios.get(`/pmdm/folder/findSearchFolderTree`).then(res => {
        // console.log(res);
        const { globalFolderTree, personalFolderTree } = res.data.object;
        this.data = this.formatTree(globalFolderTree);
        this.personalData = this.formatTree(personalFolderTree)
      })
    },
    updateTree() {
      this.$store.commit("getReloadTree");
    },
  },
  created() {
    this.getData();
  }
}
</script>
<style>
.hidde-edit {
  display: none;
}
</style>
<style scoped>
.folder-content {
  padding: 0 15px;
}

.custom-tree-node {
  display: flex;
}

.xx {}

.btns {
  margin-left: auto
}
</style>